<script>
  export let value = 0;
  export let isClicked = false;
  export let handleMouseDown = () => {};

  export let placeholder = "";
  export let max = undefined;
  export let min = undefined;
  export let buttonText = "";

  let isOutOfRange = false;
  // Nur Eingaben des Nutzers machen den Wert "offen"; setzt die Ansicht den
  // Wert selbst (z. B. automatische Schwelle), gilt er als bereits angewendet.
  let isDirty = false;

  $: {
    const belowMin = min !== undefined && value < min;
    const aboveMax = max !== undefined && value > max;
    isOutOfRange = belowMin || aboveMax;
  }

  $: isEmpty = value === null || value === undefined || value === "";
  $: canApply = isDirty && !isOutOfRange && !isEmpty;

  function apply() {
    if (!canApply) return;
    isDirty = false;
    handleMouseDown();
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      apply();
    }
  }

  function mouseDown() {
    if (!canApply) return;
    isClicked = true;
    apply();
  }

  function handleMouseUp() {
    isClicked = false;
  }

  function handleMouseLeave() {
    isClicked = false;
  }
</script>

<div>
  <div class="input_wrapper">
    <div class="label">{buttonText}</div>
    <div class="buttons_wrapper number_selector">
      <div class="container">
        <div>
          <input
            type="number"
            {placeholder}
            bind:value
            {max}
            {min}
            on:input={() => (isDirty = true)}
            on:keydown={handleKeyDown}
          />
        </div>
      </div>
    </div>
    <div
      role="button"
      tabindex="0"
      class="group_button {isClicked ? 'clicked' : ''} {canApply
        ? ''
        : 'disabled'}"
      on:mousedown={mouseDown}
      on:mouseup={handleMouseUp}
      on:mouseleave={handleMouseLeave}
      on:keydown={handleKeyDown}
    >
      Apply
    </div>
  </div>
  {#if isOutOfRange}
    <div class="error_message">
      Value must be
      {#if min !== undefined}
        ≥ {min}{/if}
      {#if min !== undefined && max !== undefined}
        and
      {/if}
      {#if max !== undefined}
        ≤ {max}{/if}
    </div>
  {/if}
</div>

<style>
  .buttons_wrapper {
    display: flex;
    gap: 0.5rem;
    user-select: none;
  }

  .number_selector {
    display: flex;
    align-items: center;
    height: 3rem;
    margin-left: 0.3rem;
  }

  .input_wrapper {
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
    background-color: var(--pax-black);
    color: var(--pax-white);
    padding: 0 0.3rem 0 0.3rem;
  }

  input {
    border: none;
    padding: 0 0.5rem;
    height: auto;
    width: 4rem;
  }

  .label {
    padding: 0 0.7rem;
    user-select: none;
    white-space: nowrap;
  }

  .group_button {
    margin-left: 0.3rem;
    height: 2.4rem;
    width: fit-content;
    display: flex;
    border-radius: 0.5rem;
    background-color: var(--pax-black);
    color: var(--pax-white);
    justify-content: center;
    align-items: center;
    padding: 0 1rem;
    cursor: pointer;
    transition: 100ms ease-in-out;
    user-select: none;
  }

  .group_button:hover {
    background-color: var(--pax-white);
    color: var(--pax-black);
  }

  .clicked:hover {
    border-color: white;
    color: var(--pax-grey);
    border-bottom: inset;
    border-top: groove;
  }

  input:focus {
    outline: none;
  }

  .container {
    background-color: var(--pax-white);
    color: var(--pax-black);
    border-radius: 0.5rem;
    align-items: center;
    display: flex;
    gap: 0.5rem;
    height: 2.4rem;
    padding: 0 0.3rem;
  }

  .group_button.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .error_message {
    color: var(--pax-red, red);
    font-size: 0.75rem;
    margin-left: 0.5rem;
    margin-top: 0.25rem;
  }
</style>
